<template>
  <span v-if="element.type == 'button' && meaningIndex != -1">
    <div
      :id="getId()"
      class="unsafe-word"
    >{{element.meaning.word}}</div>
    <b-popover
      :target="getId()"
      triggers="hover"
      placement="top"
      variant="warning"
    >
      <template v-slot:title>{{element.meaning.word}}</template>
      <Meaning
        v-bind:key="index"
        as="plain"
        v-bind:index="(meanings.length > 1)?index:-1"
        v-bind:taiwan="taiwanMeaning"
        v-bind:china="chinaMeaning"
        v-bind:english="english"
      ></Meaning>
    </b-popover>
  </span>
  <span v-else-if="element.type == 'text'">{{element.meaning.word}}</span>
</template>

<script>
/*
//multiple components in one vue file?
// inline component with template string 👍
const HelloWorld = Vue.component('hello-world', {
  props: ['msg'],
  template: `<div>
    <h1>Hello world</h1>
    <div>{{ this.msg }}</div>
  </div>`
});
*/

import Meaning from "@/components/Meaning.vue";

export default {
  name: "SentenceChunk",
  components: {
    Meaning
  },
  props: {
    element: Object,
    sentence: String,
    index: Number
  },
  computed: {
    meanings: function() {
      return this.element.meaning.meanings;
    },
    meaningIndex: function() {
      for (var i = 0; i < this.meanings.length; i++) {
        if (
          !this.meanings[i].taiwan ||
          this.meanings[i].taiwan.includes("即")
        ) {
          //find china-only words
          return i;
        }
      }
      return -1;
    },
    taiwanMeaning: function() {
      if (this.meaningIndex == -1) {
        return "";
      }
      return this.meanings[this.meaningIndex].taiwan;
    },
    chinaMeaning: function() {
      if (this.meaningIndex == -1) {
        return "";
      }
      return this.meanings[this.meaningIndex].china;
    }
  },
  methods: {
    getId: function() {
      return "button-popover-" + this.index;
    }
  }
};
</script>

<style scoped>
.unsafe-word {
  border-radius: 3px;
  background-color: #f1625b;
  color: #082213;
  display: inline;
}
.unsafe-word:hover {
  background-color: white;
}
</style>